import { TimelineEngine } from '@xzdarcy/react-timeline-editor';
import { checkPreloadedAudio } from '@/components/Timeline/utils.ts';

// 音频控制类
class AudioControl {
  // 缓存音频元素的映射
  cacheMap: Record<string, HTMLAudioElement> = {};

  // 监听器映射，用于存储时间监听器
  listenerMap: Record<
    string,
    {
      time?: (data: { time: number }) => void; // 时间监听器的类型
    }
  > = {};

  // 启动音频播放
  start(data: {
    id: string; // 音频的唯一标识
    engine: TimelineEngine; // 时间线引擎
    src: string; // 音频源
    startTime: number; // 音频开始时间
    time: number; // 当前时间
    from: number; // 从哪个时间开始播放
    volume: number; // 音量
    speed: number; // 播放速度
  }) {
    const { id, src, startTime, time, from, engine, volume, speed } = data;
    let item: HTMLAudioElement;

    // 如果缓存中已有该音频，则直接使用
    if (this.cacheMap[id] && this.cacheMap[id].src === src) {
      item = this.cacheMap[id];
      item.volume = volume; // 设置音量
      item.playbackRate = speed; // 设置播放速度
      item.currentTime = (time - startTime) * speed + from; // 设置当前播放时间
      item.play(); // 播放音频
    } else {
      item = checkPreloadedAudio(src);
      if (!item) {
        item = new Audio();
        item.autoplay = true; // 自动播放
        item.src = src; // 设置音频源
        // 监听音频数据加载完成事件
        item.addEventListener('loadeddata', () => {
          item.currentTime = (time - startTime) * speed + from; // 设置当前播放时间
          item.playbackRate = speed; // 设置播放速度
        });
      } else {
        item.play();
      }
      item.preservesPitch = true; // 保持音调
      item.volume = volume; // 设置音量
      item.currentTime = (time - startTime) * speed + from; // 设置当前播放时间
      item.playbackRate = speed; // 设置播放速度
      this.cacheMap[id] = item; // 将音频元素缓存
    }

    // 时间监听器，用于更新当前播放时间
    const timeListener = (data: { time: number }) => {
      const { time } = data;
      item.currentTime = (time - startTime) * speed + from; // 更新当前播放时间
    };

    // 如果没有该音频的监听器，则初始化
    if (!this.listenerMap[id]) this.listenerMap[id] = {};
    engine.on('afterSetTime', timeListener); // 注册时间监听器
    this.listenerMap[id].time = timeListener; // 保存监听器
  }

  // 停止音频播放
  stop(data: { id: string; engine: TimelineEngine }) {
    const { id, engine } = data;
    if (this.cacheMap[id]) {
      const item = this.cacheMap[id];
      item.pause(); // 暂停音频
      if (this.listenerMap[id]) {
        // 移除时间监听器
        this.listenerMap[id].time && engine.off('afterSetTime', this.listenerMap[id].time);
        delete this.listenerMap[id]; // 删除监听器映射
      }
    }
  }
}

// 导出音频控制实例
export default new AudioControl();
